import type { PaginatedApiResponseData } from 'api/_types';

import type { ServicesProfile, ServicesProfileDTO } from '../../servicesProfile.types';
import parseServicesProfileForFE from '../parseServicesProfileForFE/parseServicesProfileForFE';

const parseServicesProfileListForFE = (servicesProfileDTO: PaginatedApiResponseData<ServicesProfileDTO>): ServicesProfile[] =>
  servicesProfileDTO.results.map(parseServicesProfileForFE);

export default parseServicesProfileListForFE;
